import type {XYPosition} from 'reactflow';

import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

// Node positions by node ID, per analysis (`clientStateId`); shared so add-step can pin a branched node.
const nodePositionsGlobalState = makeUseGlobalClientState<{[nodeId: string]: XYPosition}>({});

export default nodePositionsGlobalState;
